// extracted by mini-css-extract-plugin
module.exports = {"main":"user-profile_main__2HATH","button":"user-profile_button__6MGna"};